import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group'

class Animate extends React.Component {

  static propTypes = {
    children: PropTypes.any,
    show: PropTypes.bool,
  }

  static defaultProps = {
    show: true,
    transitionEnterTimeout: 500,
    transitionLeaveTimeout: 1000,
  }

  ensureChildArray(children) {
    return Array.isArray(children) ? children : [children];
  }

  render() {
    const {show, children, ...transProps } = this.props;

    return <CSSTransitionGroup {...transProps}>
      {show ? this.ensureChildArray(children) : []}
    </CSSTransitionGroup>;
  }
}

module.exports = Animate;



// WEBPACK FOOTER //
// ./src/components/animate.js